import type { CartLineItem } from '@/modules/cart/domain/CartLineItem';

import { mapCartLineItemToCartItem } from './mapCartLineItemToCartItem';

const CART_ITEMS_ATTR = 'cart_items';
const EMPTY_CART_VALUE = 'empty';

export const syncCartItemsUserAttribute = (lineItems: CartLineItem[]): void => {
  if (!window.braze) return;

  const user = window.braze.getUser?.();
  if (!user) return;

  if (!lineItems || lineItems.length === 0) {
    user.setCustomUserAttribute(CART_ITEMS_ATTR, [EMPTY_CART_VALUE]);
    return;
  }

  const cartItems = lineItems.map(mapCartLineItemToCartItem);

  user.setCustomUserAttribute(CART_ITEMS_ATTR, cartItems);
};
